import StickyJS from "sticky-js";

/**
 * Stickies
 *
 * To make an element stick, add the class ".js--sticky" to it.
 * It will then stick to the boundaries of the closest
 * parent element that has [data-sticky-container]
 */
export default class Sticky {

	constructor( selector = ".js--sticky", options = {} ) {
		this.selector = selector;
		this.options  = options;
		this.sticky   = new StickyJS( selector, this.getOptions() );
	}

	static getHeaderHeight() {
		const header = document.querySelector( ".js--site-header" );
		return header.scrollHeight;
	}

	static getAdminBarHeight() {
		const adminBar = document.querySelector( "#wpadminbar" );
		if ( adminBar ) {
			return adminBar.scrollHeight;
		} else {
			return 0;
		}
	}

	getOptions() {
		return {
			...{
				marginTop: Sticky.getHeaderHeight() + Sticky.getAdminBarHeight(),
				stickyClass: "is-stuck"
			},
			...this.options
		};
	}

}
